import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader.vue"
import StarterHeader from "./layout/starter/StarterHeader.vue";
import StarterFooter from "./layout/starter/StarterFooter.vue";
import Home from "./views/Home.vue";
import ContactMe from "./views/ContactMe.vue";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  mode : 'history',
  routes: [
    {
      path: "/",
      name: "Home",
      components: {
        header: AppHeader,
        default: Home,
        footer: StarterFooter
      },
      meta : {
        title : 'Ragini Sinha | Certified Coach'
      }
    },
    {
      path: "/contact-me",
      name: "Contact Me",
      components: {
        header: AppHeader,
        default: ContactMe,
        footer: StarterFooter
      },
      meta : {
        title : 'Contact Me | Ragini Sinha | Certified Coach'
      }
    },
    
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});


